import validate from "/usr/src/app/content/n3-spas-b2b06272-fe8c-423c-8ee9-699df1232123/b2c-build/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/usr/src/app/content/n3-spas-b2b06272-fe8c-423c-8ee9-699df1232123/b2c-build/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {}